import { openDB } from 'idb';

const DB = 'cables-offline';
const STORE = 'pending';

// Evento de ventana que avisa a los indicadores que la cola cambió, para que
// no esperen al siguiente sondeo.
export const EVENTO_COLA = 'cables-cola-cambio';

const avisar = () => {
  try {
    window.dispatchEvent(new Event(EVENTO_COLA));
  } catch (e) { /* entorno sin ventana */ }
};

function db() {
  return openDB(DB, 1, {
    upgrade(d) {
      if (!d.objectStoreNames.contains(STORE)) d.createObjectStore(STORE, { keyPath: 'id' });
    },
  });
}

// job: { id, record, firmaBlob, fotoBlobs, detalles }  (keyPath id → idempotente)
// Cada job lleva además su historial de envío: intentos, ultimoError
// ({ tipo: 'red'|'permanente', motivo, detalle, at }) y permanente (true cuando
// la base lo rechazó por algo que reintentar solo no arregla). Un job nunca se
// borra por error: solo sale de la cola cuando la base confirma que lo tiene.
export async function enqueue(job) {
  const d = await db();
  const previo = await d.get(STORE, job.id);
  await d.put(STORE, {
    ...job,
    enqueuedAt: previo?.enqueuedAt ?? job.enqueuedAt ?? Date.now(),
    intentos: previo?.intentos ?? 0,
    ultimoError: previo?.ultimoError ?? null,
    permanente: previo?.permanente ?? false,
  });
  avisar();
}
export async function listPending() {
  const d = await db();
  return d.getAll(STORE);
}
export async function countPending() {
  const d = await db();
  return d.count(STORE);
}
export async function removeJob(id) {
  const d = await db();
  await d.delete(STORE, id);
  avisar();
}

// error null = reintento manual: se quita la marca permanente para que el
// próximo envío lo incluya (no cuenta como intento).
export async function registrarIntento(id, error) {
  const d = await db();
  const j = await d.get(STORE, id);
  if (!j) return;
  if (!error) {
    await d.put(STORE, { ...j, permanente: false });
  } else {
    await d.put(STORE, {
      ...j,
      intentos: (j.intentos || 0) + 1,
      ultimoError: { tipo: error.tipo, motivo: error.motivo || '', detalle: error.detalle || '', at: Date.now() },
      permanente: error.tipo === 'permanente',
    });
  }
  avisar();
}

// Lo que necesitan los indicadores, sin los Blobs. Del más viejo al más nuevo.
export async function resumenCola() {
  const jobs = await listPending();
  const trabajos = jobs
    .map((j) => ({
      id: j.id,
      fecha: j.record?.fecha ?? null,
      guia: j.record?.guia_nombre ?? '',
      enqueuedAt: j.enqueuedAt ?? null,
      intentos: j.intentos || 0,
      ultimoError: j.ultimoError || null,
      permanente: !!j.permanente,
    }))
    .sort((a, b) => (a.enqueuedAt || 0) - (b.enqueuedAt || 0));
  return {
    total: trabajos.length,
    conError: trabajos.filter((t) => t.permanente).length,
    masAntiguo: trabajos.length ? trabajos[0].enqueuedAt : null,
    trabajos,
  };
}
